import { translate } from "../../util/translate"

export const headers = [
  { text: translate['serviceReport.label.itemName'], value: 'item.name' },
  { text: translate['serviceReport.label.itemDescription'], value: 'item.description' },
  { text: translate['serviceReport.label.quantity'], value: 'quantity' },
  {
    text: '',
    align: 'center',
    value: 'data-table-expand',
    width: 50,
  },
]

export const quoteTableHeaders = [
  {
    text: translate['quote.label.name'],
    value: 'item_name',
    width: 150,
  },
  {
    text: translate['quote.label.category'],
    value: 'item_category_name',
    width: 150,
  },
  {
    text: translate['quote.label.quantity'],
    value: 'service_report_item_quantity',
    align: 'center',
    width: 50,
  },
  {
    text: translate['quote.label.amount'],
    value: 'calculated_price',
    align: 'right',
    width: 150,
  },
  {
    text: translate['quote.label.accepted'],
    value: 'accepted',
    align: 'right',
    width: 50,
  },
]
